import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBbnZybxc64nhwaBVgLKcDW2XKM1Iz29nE",
    authDomain: "first-app-e59d5.firebaseapp.com",
    databaseURL: "https://first-app-e59d5.firebaseio.com",
    projectId: "first-app-e59d5",
    storageBucket: "first-app-e59d5.appspot.com",
    messagingSenderId: "508509302868",
    appId: "1:508509302868:web:3465a3b280c65c9fcb3dc1",
    measurementId: "G-G8HX3ZN4L5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;